const isEmpty = require("lodash.isempty");

export default isEmpty;
